import { wordOne } from "./wordTest1";
import { wordTwo } from "./wordTest2";
import { wordThree } from "./wordTest3";
import { wordFour } from "./wordTest4";
import { wordFive } from "./wordTest5";
import { wordSix } from "./wordTest6";
import { wordSeven } from "./wordTest7";
import { wordEight } from "./wordTest8";
import { wordNine } from "./wordTest9";
import { wordTen } from "./wordTest10";

export const words = {
  one: wordOne,
  two: wordTwo,
  three: wordThree,
  four: wordFour,
  five: wordFive,
  six: wordSix,
  seven: wordSeven,
  eight: wordEight,
  nine: wordNine,
  ten: wordTen,
};
